/*
 * <copyright company="Argenbright Innovations Lab">
 *        copyright (c) Argenbright Innovations Lab, an Argenbright Holdings Company.  All rights reserved.
 * </copyright>
 */
export interface ICustomAPIEndpoint {
  endpoint: string;
  name: string;
  region: string;
}

interface GraphQLError {
  message: string;
}

interface GraphQLErrorLocations {
  column: number;
  line: number;
}
export interface IGraphQLError {
  errors: GraphQLError;
  locations: GraphQLErrorLocations[];
}

export interface IGraphQLResponse {
  data?: any;
  errors?: any;
}

export enum ApproverType {
  Vendor = 'Vendor',
  Customer = 'Customer',
  Supervisor = 'Supervisor',
  PrimeVendor = 'PrimeVendor',
}

export enum JobStatus {
  Draft = 'Draft',
  Awarded = 'Awarded',
  OpenToBid = 'OpenToBid',
  Completed = 'Completed',
  Incomplete = 'Incomplete',
  InProgress = 'InProgress',
  Closed = 'Closed',
  Expired = 'Expired',
  Rejected = 'Rejected',
  PendingEstimation = 'PendingEstimation',
}

export type RescheduleWorkDayInput = {
  workOrderId?: string | null;
  workDayId: string;
  newDate: string;
  startTime?: string | null;
  endTime?: string | null;
  punchInGraceMinutes?: number;
  punchOutGraceMinutes?: number;
  endDateOffset?: number | null;
};

export interface ServiceTaskMapping {
  type?: string;
  woScheduleMasterId: string;
  mdServiceId: string;
  mdServiceName: string;
  mdServiceDescription: string;
  tasks?: {
    mdTaskId: string;
    mdTaskName: string;
    mdTaskDescription: string;
    isProofOfCompletionRequired?: boolean;
    isInspectionRequired?: boolean;
    inspectionEntity?: string;
    subTasks: {
      mdTaskId?: string;
      mdTaskName: string;
      mdTaskDescription: string;
      creationType?: string;
    }[];
  }[];
  serviceMeasure: number;
  mdServiceUnits: string;
  fromDate: string;
  endDate: string;
  customerId: string;
}

export interface CreateTaskDto {
  mdTaskId: string;
  mdTaskName?: string;
  mdTaskDescription?: string;
}

export interface TaskDto extends CreateTaskDto {
  subTasks: CreateTaskDto[];
}

export interface CreateTaskSubtaskMappingDto {
  tasks: TaskDto[];
}

export interface CreateServiceDto {
  serviceCategoryName: string;
  categoryDescription: string;
  categoryImageUrl?: string;
  mdServiceType?: string;
  orgId?: string;
  mdAreaType?: string;
  taskMasterId?: string[];
}
